import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import classNames from 'clsx';
import React, { useState } from 'react';

import StarsSquareIconButton from '@swf/components/StarsSquareIconButton/StarsSquareIconButton';
import { DocumentType } from '@swf/core/enums';

import {
  TXTCLI_National_ID_Card,
  TXTCLI_Passport,
  TXTWCL_Driving_License
} from './AMLButtonGroup.messages.json';
import styles from './AMLButtonGroup.scss';
import DrivingLicenseIcon from './assets/driving-license.svg';
import NationalIDCard from './assets/national-id-card.svg';
import PassportIcon from './assets/passport.svg';

export interface Props {
  children(documentType: DocumentType | undefined): JSX.Element | null;
  small?: boolean;
  rowLayout?: boolean;
}

const AMLButtonGroup: React.FC<Props> = ({ small, children, rowLayout }) => {
  const [documentType, setDocumentType] = useState<DocumentType>();
  const verifyAccountPassport = useFeature(FeatureFlag.VerifyAccountPassport);
  const verifyAccountNationalId = useFeature(FeatureFlag.VerifyAccountNationalId);
  const verifyAccountDrivingLicense = useFeature(FeatureFlag.VerifyAccountDrivingLicense);

  return (
    <>
      <div
        className={classNames(styles.buttonsContainer, {
          [styles.small]: small,
          [styles.rowLayout]: rowLayout
        })}
      >
        {verifyAccountPassport && (
          <StarsSquareIconButton
            small={small}
            translation={{ tag: TXTCLI_Passport }}
            Icon={PassportIcon}
            onClick={() => setDocumentType(DocumentType.Passport)}
            active={documentType === DocumentType.Passport}
            dataTestId="passport-button"
            rowLayout={rowLayout}
          />
        )}
        {verifyAccountDrivingLicense && (
          <StarsSquareIconButton
            small={small}
            translation={{ tag: TXTWCL_Driving_License }}
            Icon={DrivingLicenseIcon}
            onClick={() => setDocumentType(DocumentType.DrivingLicense)}
            active={documentType === DocumentType.DrivingLicense}
            dataTestId="driving-license-button"
            rowLayout={rowLayout}
          />
        )}
        {verifyAccountNationalId && (
          <StarsSquareIconButton
            small={small}
            translation={{ tag: TXTCLI_National_ID_Card }}
            Icon={NationalIDCard}
            onClick={() => setDocumentType(DocumentType.NationalIDCard)}
            active={documentType === DocumentType.NationalIDCard}
            dataTestId="national-id-card-button"
            rowLayout={rowLayout}
          />
        )}
      </div>
      {children(documentType)}
    </>
  );
};

export default AMLButtonGroup;
